<template>
  <div :class="isMobile ? 'events-only' : 'only-list-day has--scroll'">
    <div
      class="no_mobile no-print flex flex--end"
      style="gap: 15px;margin-bottom: 18px;"
    >
      <a
        class="clear-filters flex"
        href="javascript:void(0)"
        @click="exportToExcel"
      >
        <img src="/assets/img/svg/download.svg" alt="" />ייצוא לקובץ
      </a>

      <!-- print -->
      <div class="bt_blue print-btn-small" @click="print">
        הדפסה
      </div>
    </div>

    <div
      v-if="!surgeryList || !surgeryList.length"
      :class="isMobile ? 'no-events' : 'empty-list-day center'"
    >
      אין אירועים
    </div>
    <!-- mobile -->
    <template v-if="isMobile">
      <div
        v-for="event in surgeryList"
        :key="event.id"
        class="vuecal__event appointmentBlock"
      >
        <surg-list-event :isMobile="isMobile" :event="event" />
      </div>
    </template>
    <!-- desktop -->
    <template v-else>
      <surg-list-event
        v-for="event in surgeryList"
        :key="event.id"
        :isMobile="isMobile"
        :event="event"
      />
    </template>
    <div class="only-print" style="padding-top: 20px;">
      <b class="tx--blue2">
        כמות הניתוחים:
      </b>
      {{ surgeryList && surgeryList.length ? surgeryList.length : 0 }}
    </div>
  </div>
</template>

<script>
import SurgListEvent from "@/components/Dashboard/List/SurgListEvent.vue";
import { exportSurgeriesToExcel } from "../../../utilities/export-to-excel";

export default {
  name: "SurgeryList",
  components: { SurgListEvent },
  props: {
    surgeryList: { required: true },
    isMobile: { default: false }
  },
  methods: {
    print() {
      window.focus();
      window.print();
    },
    exportToExcel() {
      exportSurgeriesToExcel(this.surgeryList);
    }
  }
};
</script>
